import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from 'src/services/api.service';
import { LoadingService } from 'src/services/loading.service';
import { SequentialReviewDialogComponent, SequentialReviewDialogResult } from './task-panel/sequential-review-dialog/sequential-review-dialog.component';

@Injectable({
	providedIn: 'root',
})
export class FuncionesService {

	constructor(
		private apiService: ApiService,
		public loadingService: LoadingService,
		private toastr: ToastrService,
		private snackbar: MatSnackBar,
		private dialog: MatDialog
	) {
	}

	// Plan #33 fase 4: insert a sequential review after this GenericReview
	addSequentialReview(task, parent) {
		console.log("FuncionesService:addSequentialReview");

		this.dialog.open(SequentialReviewDialogComponent, {
			width: '480px',
			data: { mode: 'add', task: task }
		}).afterClosed().subscribe((result: SequentialReviewDialogResult | undefined) => {
			if (!result) { return; }
			this.loadingService.loading = true;
			this.apiService.addSequentialReview(task.id, result).subscribe({
				next: (value: any) => {
					this.loadingService.loading = false;
					if (value?.error) {
						this.snackbar.open(value.errorMessage || 'Error adding review', '', { duration: 4000 });
						return;
					}
					location.reload();
				},
				error: (err) => {
					this.loadingService.loading = false;
					console.error(err);
					this.snackbar.open('Error adding review', '', { duration: 3000 });
				},
			});
		});
	}

	// Plan #33 fase 4: edit the reviewer of an On-Hold GenericReview
	editReviewers(task, parent) {
		console.log("FuncionesService:editReviewers");

		this.dialog.open(SequentialReviewDialogComponent, {
			width: '480px',
			data: { mode: 'edit', task: task }
		}).afterClosed().subscribe((result: SequentialReviewDialogResult | undefined) => {
			if (!result) { return; }
			this.loadingService.loading = true;
			this.apiService.updateTaskReviewers(task.id, result).subscribe({
				next: (value: any) => {
					this.loadingService.loading = false;
					if (value?.error) {
						this.snackbar.open(value.errorMessage || 'Error updating reviewers', '', { duration: 4000 });
						return;
					}
					location.reload();
				},
				error: (err) => {
					this.loadingService.loading = false;
					console.error(err);
					this.snackbar.open('Error updating reviewers', '', { duration: 3000 });
				},
			});
		});
	}

	// Plan #33 fase 4: manually start a chain review whose previous link already finished
	activateReview(task, parent) {
		console.log("FuncionesService:activateReview");

		this.loadingService.loading = true;
		this.apiService.getActivateReview(task.id).subscribe({
			next: (value: any) => {
				this.loadingService.loading = false;
				if (value?.error) {
					this.snackbar.open(value.errorMessage || 'Error activating review', '', { duration: 4000 });
					return;
				}
				location.reload();
			},
			error: (err) => {
				this.loadingService.loading = false;
				console.error(err);
				this.snackbar.open('Error activating review', '', { duration: 3000 });
			},
		});
	}

	exportScreenplayTask(task) {
		console.log("FuncionesService:exportScreenplayTask");
		console.log(task);

		this.loadingService.loading = true;

		this.apiService.createScreenplay(task.uuid).subscribe({
			next: (value: any) => {
				this.loadingService.loading = false;
				console.log(value);
			}, error(err) {
				this.loadingService.loading = false;
				console.error(err);
				this.snackbar.open(err + 'ERROR', '', { duration: 3000 });
			},
		});
	}

	forceTask(task) {
		console.log("FuncionesService:forceTask");
		console.log(task);

		this.loadingService.loading = true;

		this.apiService.getForceTask(task.id).subscribe({
			next: (value: any) => {
				this.loadingService.loading = false;
				console.log(value);
			}, error(err) {
				this.loadingService.loading = false;
				console.error(err);
				this.snackbar.open(err + 'ERROR', '', { duration: 3000 });
			},
		});
	}

	forceTask2(task) {
		console.log("FuncionesService:forceTask2");
		console.log(task);

		this.loadingService.loading = true;

		this.apiService.getForceTask2(task.id).subscribe({
			next: (value: any) => {
				this.loadingService.loading = false;
				console.log(value);
				// refresh page
				location.reload();
			}, error(err) {
				this.loadingService.loading = false;
				console.error(err);
				this.snackbar.open(err + 'ERROR', '', { duration: 3000 });
			},
		});
	}

	forceBackTask(task, parent) {
		console.log("FuncionesService:forceBackTask");
		console.log(task);

		this.loadingService.loading = true;

		this.apiService.getForceBackTask(task.id).subscribe({
			next: (value: any) => {
				this.loadingService.loading = false;
				console.log(value);
				location.reload();
			}, error(err) {
				this.loadingService.loading = false;
				console.error(err);
				this.snackbar.open(err + 'ERROR', '', { duration: 3000 });
			},
		});
	}

	forceBackTask2(task, parent) {
		console.log("FuncionesService:forceBackTask2");
		console.log(task);

		this.loadingService.loading = true;

		this.apiService.getForceBackTask2(task.id).subscribe({
			next: (value: any) => {
				this.loadingService.loading = false;
				console.log(value);
				location.reload();
			}, error(err) {
				this.loadingService.loading = false;
				console.error(err);
				this.snackbar.open(err + 'ERROR', '', { duration: 3000 });
			},
		});
	}

	force1SecGap(task, parent) {
		console.log("FuncionesService:force1SecGap");
		console.log(task);

		this.loadingService.loading = true;

		this.apiService.getForce1SecGap(task.id).subscribe({
			next: (value: any) => {
				this.loadingService.loading = false;
				console.log(value);
				location.reload();
			}, error(err) {
				this.loadingService.loading = false;
				console.error(err);
				this.snackbar.open(err + 'ERROR', '', { duration: 3000 });
			},
		});
	}

	force500MilisecGap(task, parent) {
		console.log("FuncionesService:force500MilisecGap");
		console.log(task);

		this.loadingService.loading = true;

		this.apiService.getForce500MilisecGap(task.id).subscribe({
			next: (value: any) => {
				this.loadingService.loading = false;
				console.log(value);
				location.reload();
			}, error(err) {
				this.loadingService.loading = false;
				console.error(err);
				this.snackbar.open(err + 'ERROR', '', { duration: 3000 });
			},
		});
	}

	addHumanSubtitleReview(task, parent) {
		console.log("FuncionesService:addHumanSubtitleReview");
		console.log(task);

		this.loadingService.loading = true;

		this.apiService.getAddHumanSubtitleReview(task.id).subscribe({
			next: (value: any) => {
				this.loadingService.loading = false;
				console.log(value);
				location.reload();
			}, error(err) {
				this.loadingService.loading = false;
				console.error(err);
				this.snackbar.open(err + 'ERROR', '', { duration: 3000 });
			},
		});
	}

	cancelTask(task, parent) {
		console.log("FuncionesService:cancelTask");
		console.log(task);

		this.loadingService.loading = true;

		this.apiService.getCancelTask(task.id).subscribe({
			next: (value: any) => {
				this.loadingService.loading = false;
				console.log(value);
				location.reload();
			}, error(err) {
				this.loadingService.loading = false;
				console.error(err);
				this.snackbar.open(err + 'ERROR', '', { duration: 3000 });
			},
		});
	}

	urltest1(task, parent) {
		console.log("AAA urltest1");
		location.reload();
	}

	urltest2() {
		console.log("AAA urltest2");
	}

	urltest3() {
		console.log("AAA urltest3");
	}
}
